import {JoinedRoomData} from "../chatserver/sx-server";
import {Application} from "../application/application";
import vxRoomList from "../chatserver/vx-roomlist";
import logging from "../utils/log";

export class SamplerPanel
{
	currentList: JoinedRoomData[];
	w: number;
	h: number;
	vxRooms: JoinedRoomData[];
	private TAG = "[Sxc.Chat.Sampler]";
	private $items : JQuery;

	public bigList : JoinedRoomData[] = [];
	public smallList : JoinedRoomData[] = [];
	private currentRoomID: string;

	constructor(private $root : JQuery,
	            private app : Application,
	            private showBoys: boolean
		)
	{
		this.$root.addClass("sxc-empty");
		this.$items = this.$root.find(".sxccs-items");
		this.$root.find(".sxccs-more").click(() => this.shuffle());
		this.app.view.loadLayer.sampler(true);
	}

	update()
	{
		// console.log(this.TAG, "Updating sampler");

		this.app.view.loadLayer.sampler(false);

		let roomsThatFit = Math.ceil(this.h / (this.w * 9/16 + 1));

		let current = this.currentList === this.bigList ? "big" : "small";
		let last10 = this.currentList ? this.currentList.slice(0, roomsThatFit) : [];

		let sxRooms = this.app.chatServer.roomList.getSampler().filter(r => r.roomid !== this.currentRoomID);
		let vxRooms = vxRoomList.getRooms().filter(r => r.roomid !== this.currentRoomID);

		const filterByPriCat = x => {

			if (this.showBoys) return false;
			if (!x.publicData || !x.publicData.primaryCat) return false;
			if (["Boy", "BoyCouple"].indexOf(x.publicData.primaryCat) > -1) return false;
			return true;
		};

		sxRooms = sxRooms.filter(filterByPriCat);
		vxRooms = vxRooms.filter(filterByPriCat);

		this.smallList = this.getShuffledList(sxRooms, last10);
		this.bigList = this.getShuffledList([...sxRooms, ...vxRooms], last10);

		this.currentList = current === "big" ? this.bigList : this.smallList;

		// console.log(this.TAG, "Updating sampler", this.currentList, this.bigList, this.smallList);

		this.renderList();
	}

	//noinspection JSMethodCanBeStatic
	private getShuffledList(source : JoinedRoomData[], prevList : JoinedRoomData[] = null)
	{
		let prevIDs = prevList.map((i) => i.roomid);

		let weights = [];

		for (let i = 0; i < source.length; i++)
		{
			let room = source[i];

			let weight = 1000;

			if (room.roomMode === "free") weight += 1000;

			if (room.roomid.substr(0,1) === "v") {
				weight -= 50;
			}

			if ($.inArray(room.roomid, prevIDs) > -1) {
				weight = 1;
			}

			weights[i] = weight;
		}

		return SamplerPanel.weightedShuffle(source, weights);
	}

	private static weightedShuffle(values, weights)
	{
		const deck = [...values];
		const weights2 = [...weights];

		const res = [];

		let totalWeight = weights.reduce((a, b) => (a || 1) + (b || 1), 0);

		while (deck.length) {
			let rand = Math.floor(Math.random() * totalWeight);

			let i = 0;
			let selected = rand;

			while (selected > 0) {
				selected -= weights2[i];
				i += 1
			}

			i -= 1;
			if (i < 0) i = 0;

			res.push(deck[i]);
			totalWeight -= (weights2[i] || 1);
			deck.splice(i, 1);
			weights2.splice(i, 1);
		}

		return res;
	}

	private renderList()
	{
		// console.log(this.TAG, "Rendering list");

		this.$items.empty();

		const pomRoomID = this.app.getPomRoomID();

		let list;

		if (pomRoomID)
		{
			const pomRoom = this.app.chatServer.roomList.getByID(pomRoomID);
			if (pomRoom) {
				list = this.currentList.filter(r => r.roomid !== pomRoomID);
				list.unshift(pomRoom);
			} else {
				list = this.currentList;
			}
		} else {
			list = this.currentList;
		}

		// console.log(this.TAG, "list", list, this.currentList);

		if (list)
		{
			for (let room of list)
			{
				let profilePic = room.publicData.profilePic ? room.publicData.profilePic : null;

				let $room = $("<div class=\"sxccs-item\" />")
					.css({"background-image": "url(" + profilePic + ")"})
					.attr("data-action", "joinRoom")
					.attr("data-roomid", room.roomid)
					.appendTo(this.$items);

				if (room.roomid == pomRoomID) {
					$room.addClass("pom-" + (this.app.translator.lang() == "hu" ? "hu" : "en"));
				}
			}
		}

		this.$root.removeClass("sxc-empty");
		$(window).resize();
	}

	/**
	 * Places this component to the specified coordinates with the specified size
	 */
	public place(x : number, y : number, w : number, h : number) : void
	{
		this.h = h;
		this.w = w;

		this.$root.css({
			top: y,
			left: x,
			width: w,
			height: h
		});

		let roomsThatFit = Math.ceil(this.h / (this.w * 9/16 + 1));

		if (this.smallList.length < roomsThatFit)
		{
			this.$root.find(".sxccs-more").show();

			if (this.currentList !== this.bigList)
			{
				this.currentList = this.bigList;
				this.renderList();
			}
		}
		else if (this.smallList.length * 2 < roomsThatFit)
		{
			this.$root.find(".sxccs-more").hide();

			if (this.currentList !== this.smallList) {
				this.currentList = this.smallList;
				this.renderList();
			}
		}
		else
		{
			this.$root.find(".sxccs-more").show();

			if (this.currentList !== this.smallList) {
				this.currentList = this.smallList;
				this.renderList();
			}
		}
	}

	public show(visibility : boolean = true) : void
	{
		// TODO: Maybe disable updates of this comp when it's not visible. Not necessary
		this.$root[visibility ? "addClass" : "removeClass"]("sxc-visible");
	}

	setCoverSize(number : number) : void {
		this.$root.find(".sxccs-more").css("bottom", number);
	}

	shuffle():void
	{
		this.update();
	}

	isVisible()
	{
		return this.$root.is(":visible");
	}

	setVxRooms(rooms: JoinedRoomData[])
	{
		this.vxRooms = rooms;
	}

	setCurrentRoom(roomID: string)
	{
		this.currentRoomID = roomID;
	}
}
